import React from 'react';

import Container from './Container.jsx';
import { LabelValue, LabelValueTypeConfig, withLabelTokenParsing } from './Content.jsx';
import Token from '../utility/Token.jsx';
import _TypeConfig from './TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

// #region TAXES

function Taxes(props) {
    const data = props.data || {};
    const hasTaxes = data.Taxes && data.Taxes.length > 0;
    if (!props.builder && !hasTaxes) {
        return null;
    }
    const config = props.config || {};
    let blockProps = {};
    if (config.config && config.config.Block) {
        blockProps = config.config.Block;
    }
    const rowStyle = {};
    if (blockProps.rowSpacing && !Utilities.isNullOrWhitespace(blockProps.rowSpacing.value)) {
        rowStyle.paddingTop = `${blockProps.rowSpacing.value}${blockProps.rowSpacing.unit}`;
    }
    const localization = data.Gallery && data.Gallery.Localization;
    return (
        <Container
            builder={props.builder}
            className={props.className}
            config={props.config}
            onClick={props.onClick}
            onDragEnter={props.onDragEnter}
            onDragStart={props.onDragStart}>
            {
                data.Taxes &&
                data.Taxes.map((d, i) =>
                    <TaxLine
                        key={i}
                        {...props}
                        container={false}
                        data={d}
                        localization={localization}
                        rowStyle={i > 0 ? rowStyle : undefined} />
                )
            }
            {
                props.builder &&
                <tr>
                    <td>
                        {
                            !hasTaxes &&
                            Utilities.Builder.emptyBlockPlaceholder()
                        }
                        {Utilities.Builder.dragOutline()}
                    </td>
                </tr>
            }
        </Container>
    );
}
function _TaxLine(props) { return <LabelValue {...props} value={props.content} /> }
const TaxLine = withLabelTokenParsing(_TaxLine, (props, keyword, options) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.DisplayCurrency.TaxValue:
            if (data.ExchangeRate && data.ExchangeRate.Value != undefined) {
                replaceString = Token.getReplacementString(data.ExchangeRate.Value, options);
            }
            break;
        case Token.Total.Tax.Name:
            if (data.Name != undefined) {
                replaceString = data.Name;
            }
            break;
        case Token.Total.Tax.Value:
            if (data.Amount != undefined) {
                replaceString = Utilities.Format.Currency.getDisplayString(data.Amount, options && options.format, props.localization);
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const Tokens = (data) => {
    const defaultValue = Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization);
    return [
        { display: 'Tax Name', token: Token.Total.Tax.Name },
        Token.getCurrencyTokenConfig('Tax Value', defaultValue, Token.Total.Tax.Value),
        Token.getWrappedTokenConfig('Tax Value (Display Currency)', Token.DisplayCurrency.TaxValue)
    ];
};
const TypeConfig = {
    panel: {
        block: () => LabelValueTypeConfig.panel.block(2, [{
            display: 'Tax Line Spacing',
            fullWidth: true,
            group: 'block',
            name: 'rowSpacing',
            options: _TypeConfig.dropdown.measurement(),
            type: 'measurement-slider'
        }]),
        description: LabelValueTypeConfig.panel.description,
        label: () => LabelValueTypeConfig.panel.label(Utilities.wrapTextForEditor({ text: `{${Token.Total.Tax.Name}}`, token: Token.Total.Tax.Name })),
        style: LabelValueTypeConfig.panel.style,
        value: (data) => LabelValueTypeConfig.panel.value(Utilities.wrapTextForEditor({ text: `{${Token.Total.Tax.Value}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}")}`, token: Token.Total.Tax.Value }))
    }
};

// #endregion TAXES

export {
    Taxes as Component,
    Tokens,
    TypeConfig
}